import { render, staticRenderFns } from "./HolderDeleteButton.vue?vue&type=template&id=73e40a88&scoped=true&"
import script from "./HolderDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./HolderDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./HolderDeleteButton.vue?vue&type=style&index=0&id=73e40a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e40a88",
  null
  
)

export default component.exports